<template>
  <page-header-wrapper>
    <a-card>
      <div class="flex align-center">
        <div class="abox" :class="{ 'active': activeIndex == 0 }" @click="changeTab(0)">
          <img src="@/assets/images/pay/wxPay.png" alt="" class="box80">
          <div class="margin-top-sm">微信支付</div>
        </div>
        <div class="abox" :class="{ 'active': activeIndex == 1 }" @click="changeTab(1)">
          <img src="@/assets/images/pay/aliPay.png" alt="" class="box80">
          <div class="margin-top-sm">支付宝支付</div>
        </div>
        <div class="abox" :class="{ 'active': activeIndex == 2 }" @click="changeTab(2)">
          <img src="@/assets/images/pay/tonglian.png" alt="" class="box80">
          <div class="margin-top-sm">通联支付</div>
        </div>
      </div>
      <div class="margin-top">
        <div class="text-bold margin-tb">{{ currentPayTypeName }}</div>
        <a-row class="margin-bottom">
          <a-col :span="24" style="text-align: right;">
            <a-button type="primary" @click="handleAdd">
              <a-icon type="plus" />新增渠道
            </a-button>
          </a-col>
        </a-row>
        <a-table
          :columns="columns"
          :data-source="dataSource"
          :loading="loading"
          :pagination="pagination"
          row-key="id"
          @change="handleTableChange"
        >
          <template slot="clientType" slot-scope="text">
            <a-tag :color="getClientTypeColor(text)">{{ getClientTypeName(text) }}</a-tag>
          </template>
          <template slot="status" slot-scope="text">
            <a-tag :color="text === 1 ? 'green' : 'red'">{{ text === 1 ? '开启' : '关闭' }}</a-tag>
          </template>
          <template slot="action" slot-scope="text, record">
            <a-button type="link" size="small" @click="handleEdit(record)">编辑</a-button>
            <a-popconfirm
              title="确定要删除这条记录吗？"
              ok-text="确定"
              cancel-text="取消"
              @confirm="handleDelete(record)"
            >
              <a-button type="link" size="small" danger>删除</a-button>
            </a-popconfirm>
          </template>
        </a-table>
      </div>
    </a-card>

    <!-- 新增/编辑弹窗 -->
    <a-modal
      :title="modalTitle"
      :visible="modalVisible"
      :width="800"
      :confirm-loading="submitLoading"
      @ok="handleSubmit"
      @cancel="handleCancel"
    >
      <a-form-model
        ref="form"
        :model="form"
        :rules="rules"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 18 }"
      >
        <a-form-model-item label="渠道名称" prop="name">
          <a-input v-model="form.name" placeholder="请输入渠道名称" />
        </a-form-model-item>
        <a-form-model-item label="业务端" prop="clientType">
          <a-select v-model="form.clientType" placeholder="请选择业务端">
            <a-select-option value="user_app">用户APP</a-select-option>
            <a-select-option value="user_miniprogram">用户微信小程序</a-select-option>
            <a-select-option value="master_app">师傅APP</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="开启状态" prop="status">
          <a-radio-group v-model="form.status">
            <a-radio :value="1">开启</a-radio>
            <a-radio :value="0">关闭</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="支付类型" prop="type">
          <a-radio-group v-model="form.type" @change="handleTypeChange">
            <a-radio :value="1">普通</a-radio>
            <a-radio :value="2">服务商</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-divider>渠道配置</a-divider>
        <wx-pay
          v-if="activeIndex === 0"
          ref="configComponent"
          :isEdit="true"
          :type="form.type"
          :autoLoad="false"
        />
        <ali-pay
          v-if="activeIndex === 1"
          ref="configComponent"
          :isEdit="true"
          :type="form.type"
          :autoLoad="false"
        />
        <div v-if="activeIndex === 2" style="text-align: center; padding: 20px;">
          通联支付配置暂未实现
        </div>
      </a-form-model>
    </a-modal>
  </page-header-wrapper>
</template>

<script>
import * as paychannel from '@/api/pay/pay.js'
import wxPay from './wxPay.vue'
import aliPay from './aliPay.vue'

export default {
  name: "pay",
  components: {
    wxPay,
    aliPay
  },
  data() {
    return {
      activeIndex: 0, // 选中的支付方式：0-微信，1-支付宝，2-通联
      loading: false,
      submitLoading: false,
      modalVisible: false,
      modalTitle: '新增渠道',
      isEdit: false,
      form: {
        id: null,
        name: '',
        code: '',
        clientType: '',
        status: 1,
        type: 1, // 1-普通，2-服务商
        config: ''
      },
      rules: {
        name: [{ required: true, message: '请输入渠道名称', trigger: 'blur' }],
        clientType: [{ required: true, message: '请选择业务端', trigger: 'change' }],
        status: [{ required: true, message: '请选择开启状态', trigger: 'change' }],
        type: [{ required: true, message: '请选择支付类型', trigger: 'change' }]
      },
      columns: [
        {
          title: '渠道名称',
          dataIndex: 'name',
          key: 'name'
        },
        {
          title: '业务端',
          dataIndex: 'clientType',
          key: 'clientType',
          scopedSlots: { customRender: 'clientType' }
        },
        {
          title: '渠道编码',
          dataIndex: 'code',
          key: 'code'
        },
        {
          title: '状态',
          dataIndex: 'status',
          key: 'status',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '操作',
          key: 'action',
          scopedSlots: { customRender: 'action' },
          width: 150
        }
      ],
      dataSource: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: (total) => `共 ${total} 条`
      }
    }
  },
  computed: {
    currentPayTypeName() {
      const names = ['微信支付', '支付宝支付', '通联支付']
      return names[this.activeIndex] || '支付渠道'
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    /**
     * 切换支付方式
     */
    changeTab(index) {
      if (index === this.activeIndex) return
      this.activeIndex = index
      this.pagination.current = 1
      this.loadData()
    },
    /**
     * 加载列表数据
     */
    loadData() {
      this.loading = true
      const params = {
        current: this.pagination.current,
        size: this.pagination.pageSize
      }
      
      // 根据选中的支付方式过滤
      // 使用模糊查询匹配支付类型
      if (this.activeIndex === 0) {
        // 微信支付：code包含wx或WECHAT
        params.code = 'WECHAT'
      } else if (this.activeIndex === 1) {
        // 支付宝支付：code包含alipay或ALIPAY
        params.code = 'ALIPAY'
      } else if (this.activeIndex === 2) {
        // 通联支付：code包含allinpay或ALLINPAY
        params.code = 'ALLINPAY'
      }

      paychannel.list(params).then(res => {
        this.loading = false
        if (res.success) {
          this.dataSource = res.data.records || []
          this.pagination.total = res.data.total || 0
        } else {
          this.$message.error(res.message || '加载数据失败')
        }
      }).catch(err => {
        this.loading = false
        this.$message.error('加载数据失败')
      })
    },
    /**
     * 表格变化
     */
    handleTableChange(pagination) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.loadData()
    },
    /**
     * 新增
     */
    handleAdd() {
      this.isEdit = false
      this.modalTitle = '新增渠道'
      this.form = {
        id: null,
        name: '',
        code: '',
        clientType: '',
        status: 1,
        type: 1,
        config: ''
      }
      this.modalVisible = true
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
        // 重置配置组件
        if (this.$refs.configComponent) {
          this.$refs.configComponent.resetForm()
        }
      })
    },
    /**
     * 编辑
     */
    handleEdit(record) {
      this.isEdit = true
      this.modalTitle = '编辑渠道'
      paychannel.detail({ id: record.id }).then(res => {
        if (res.success && res.data) {
          const data = res.data
          this.form = {
            id: data.id,
            name: data.name || '',
            code: data.code || '',
            clientType: data.clientType || '',
            status: data.status !== undefined ? data.status : 1,
            type: this.getTypeFromCode(data.code),
            config: data.config || ''
          }
          this.modalVisible = true
          this.$nextTick(() => {
            if (this.$refs.form) {
              this.$refs.form.resetFields()
            }
            // 延迟设置配置组件的值，等待组件初始化完成
            this.$nextTick(() => {
              setTimeout(() => {
                if (this.$refs.configComponent && data.config) {
                  try {
                    const configObj = JSON.parse(data.config)
                    // 更新配置组件的configObj
                    Object.keys(configObj).forEach(key => {
                      this.$set(this.$refs.configComponent.form.configObj, key, configObj[key])
                    })
                    // 设置状态
                    if (data.status !== undefined) {
                      this.$refs.configComponent.form.status = data.status
                      this.$refs.configComponent.form.statusChecked = data.status === 1
                    }
                  } catch (e) {
                    console.error('解析配置失败', e)
                  }
                }
              }, 100)
            })
          })
        } else {
          this.$message.error(res.message || '获取详情失败')
        }
      }).catch(err => {
        this.$message.error('获取详情失败')
      })
    },
    /**删除 */
    handleDelete(record) {
      paychannel.del({ id: record.id }).then(res => {
        if (res.success) {
          this.$message.success('删除成功')
          this.loadData()
        } else {
          this.$message.error(res.message || '删除失败')
        }
      }).catch(err => {
        this.$message.error('删除失败')
      })
    },
    /**提交表单 */
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (!valid) {
          return false
        }
        
        // 验证配置组件
        if (this.$refs.configComponent && this.$refs.configComponent.$refs.ruleForm) {
          this.$refs.configComponent.$refs.ruleForm.validate(valid => {
            if (!valid) {
              return false
            }
            this.submitData()
          })
        } else if (this.activeIndex === 2) {
          // 通联支付暂不支持
          this.$message.warning('通联支付配置暂未实现')
          return false
        } else {
          this.submitData()
        }
      })
    },
    /**提交数据 */
    submitData() {
      this.submitLoading = true
      
      // 获取配置
      if (this.$refs.configComponent) {
        const configObj = this.$refs.configComponent.form.configObj
        this.form.config = JSON.stringify(configObj)
      }
      
      const apiUrl = this.isEdit ? paychannel.edit : paychannel.add
      apiUrl(this.form).then(res => {
        this.submitLoading = false
        if (res.success) {
          this.$message.success(this.isEdit ? '更新成功' : '新增成功')
          this.modalVisible = false
          this.loadData()
        } else {
          this.$message.error(res.message || '操作失败')
        }
      }).catch(err => {
        this.submitLoading = false
        this.$message.error('操作失败')
      })
    },
    /**从code中提取type */
    getTypeFromCode(code) {
      if (!code) return 1
      if (code.includes('PARTNER')) {
        return 2
      }
      return 1
    },
    /**支付类型变化 */
    handleTypeChange() {
      // 支付类型变化时，可能需要更新配置组件
      this.$nextTick(() => {
        if (this.$refs.configComponent) {
          this.$refs.configComponent.type = this.form.type
        }
      })
    },
    /**取消 */
    handleCancel() {
      this.modalVisible = false
      this.form = {
        id: null,
        name: '',
        code: '',
        clientType: '',
        status: 1,
        type: 1,
        config: ''
      }
    },
    /**获取业务端名称 */
    getClientTypeName(clientType) {
      const map = {
        'user_app': '用户APP',
        'user_miniprogram': '用户微信小程序',
        'master_app': '师傅APP'
      }
      return map[clientType] || clientType
    },
    /**获取业务端颜色 */
    getClientTypeColor(clientType) {
      const map = {
        'user_app': 'blue',
        'user_miniprogram': 'green',
        'master_app': 'orange'
      }
      return map[clientType] || 'default'
    }
  }
}
</script>

<style scoped lang="less">
.abox {
  width: 120px;
  padding: 20px 0;
  text-align: center;
  cursor: pointer;
}

.abox.active {
  border: 1px solid rgb(54, 187, 54);
  border-radius: 5px;
}

.box80 {
  width: 50px;
  height: 50px;
}
</style>
